/**
 * PureBac FAQ accordion.
 * Custom element <pb-faq> — clicking a question opens it and closes the others,
 * mirroring the reference design's behaviour. Defined as a custom element so it
 * re-initialises automatically when the Shopify theme editor re-renders the section.
 */
class PbFaq extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('.pb-faq-q');
      if (!trigger || !this.contains(trigger)) return;

      const item = trigger.closest('.pb-faq-item');
      if (!item) return;

      const willOpen = !item.classList.contains('is-open');

      this.querySelectorAll('.pb-faq-item').forEach((el) => {
        el.classList.remove('is-open');
        const q = el.querySelector('.pb-faq-q');
        const icon = el.querySelector('.pb-faq-icon');
        if (q) q.setAttribute('aria-expanded', 'false');
        if (icon) icon.textContent = '+';
      });

      if (willOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        const icon = trigger.querySelector('.pb-faq-icon');
        if (icon) icon.textContent = '−';
      }
    });
  }
}

if (!customElements.get('pb-faq')) {
  customElements.define('pb-faq', PbFaq);
}
